import { render, staticRenderFns } from "./DigiBoardListForCalendar.vue?vue&type=template&id=1e8dd172&scoped=true&"
import script from "./DigiBoardListForCalendar.vue?vue&type=script&lang=js&"
export * from "./DigiBoardListForCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DigiBoardListForCalendar.vue?vue&type=style&index=0&id=1e8dd172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8dd172",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VIcon,VSpacer})
